import { render, staticRenderFns } from "./TaskHistoryTable.vue?vue&type=template&id=c227c150&"
import script from "./TaskHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TaskHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports